/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../common";
import type {
  ManagerLogic2,
  ManagerLogic2Interface,
} from "../../../contracts/manager/ManagerLogic2";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "ticketId",
        type: "bytes32",
      },
    ],
    name: "TicketWithdraw",
    type: "event",
  },
  {
    stateMutability: "payable",
    type: "fallback",
  },
  {
    inputs: [],
    name: "accessControl",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newAssociatedOperator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "flag",
        type: "bool",
      },
    ],
    name: "setAssociatedOperator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
] as const;

const _bytecode =
  "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";

type ManagerLogic2ConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ManagerLogic2ConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class ManagerLogic2__factory extends ContractFactory {
  constructor(...args: ManagerLogic2ConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<ManagerLogic2> {
    return super.deploy(overrides || {}) as Promise<ManagerLogic2>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): ManagerLogic2 {
    return super.attach(address) as ManagerLogic2;
  }
  override connect(signer: Signer): ManagerLogic2__factory {
    return super.connect(signer) as ManagerLogic2__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ManagerLogic2Interface {
    return new utils.Interface(_abi) as ManagerLogic2Interface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ManagerLogic2 {
    return new Contract(address, _abi, signerOrProvider) as ManagerLogic2;
  }
}
